/* eslint-disable */
import { Grid, TextField, Typography, Box } from "@mui/material";
import { useState, useEffect } from "react";
import { getBandejaActual } from "../../services/ProduccionService";
import Message from "../../utils/Message";
//
// ###########################################################################
//
const DatosBandejaActual = (props) => {
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [data, setData] = useState({});
  const [tieneBandeja, setTieneBandeja] = useState(false);
  //
  // ################################################################################
  //
  useEffect(() => {
    const loadDatosBandejaActual = async () => {
      const response = await getBandejaActual(props.anteojoArreglo, props.idGcAnteojoArreglo);

      if (response.ok) {
        let _response = response.data.data;
        if (Object.keys(_response).length !== 0) {
          setData(_response);
          props.setBandejaActual(_response.bandeja);
          setTieneBandeja(true);
        }
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
        return;
      }
    };
    loadDatosBandejaActual();
  }, []);
  //
  // ################################################################################
  //
  return (
    <>
      {tieneBandeja && (
        <Box
          sx={{
            border: "1px solid LightGrey",
            borderRadius: "5px",
            p: 1,
            mb: 1,
          }}
        >
          <Grid container spacing={1} sx={{ mb: 1 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography variant="h6" gutterBottom>
                Bandeja actual
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={2} lg={2}>
              <TextField
                id="bandeja"
                label="Bandeja actual"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="bandeja"
                value={data.bandeja ?? ""}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={2} lg={2}>
              <TextField
                id="fecha_estado"
                label="Fecha de asignación"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="fecha_estado"
                value={data.fecha_estado ?? ""}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={2} lg={2}>
              <TextField
                id="descripcion_area"
                label="Asignada en"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="descripcion_area"
                value={data.descripcion_area ?? ""}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={4}>
              <TextField
                id="observaciones"
                label="Observaciones"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="observaciones"
                value={data.observaciones ?? ""}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={2} lg={2}>
              <TextField
                id="usuario_usuario"
                label="Asignó"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="usuario_usuario"
                value={data.usuario_usuario ?? ""}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </Box>
      )}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}
    </>
  );
};
export default DatosBandejaActual;
